/* State module for itemperties information, shared across the app. If a page needs to store specific information, use a module for the given page. */

// Mutations and Actions
import BaseModule from '@/store/baseModule';
import actions from './actions';
import mutations from './mutations';

const makeSeveralCurrentsModule = ({
  attributesObjRef,
  attributesObj,
  makeQueryParams,
  searchAttributesArray,
  sortChoices,
  defaultSortBy,
  defaultASC,
  hasDefaultFilters,
  makeHttpParamsUrl,
  serviceAPI,
  customGetters,
  customMutations,
  customActions,
}) => {
  const baseModule = new BaseModule({
    attributesObj,
    searchAttributesArray,
    attributesObjRef,
    sortChoices,
    defaultSortBy,
    defaultASC,
    hasDefaultFilters,
    makeQueryParams,
    serviceAPI,
    customGetters,
    customMutations,
    customActions,
  });
  return {
    ...baseModule,
    state: {
      ...baseModule.state,
      currents: [],
      active: {
        id: null,
        data: {},
        isLoading: false,
        error: null,
        recurrence: null,
        is_paused: null,
      },
    },
    getters: {
      ...baseModule.getters,
      currents: (state) => state.currents,
      active: (state) => state.active.data,
      activeRecurrence: (state) => state.active.recurrence,
      activeId: (state) => state.active.id,
      activeDaughterId: (state) => state.active.daughter_request_id,
      isActiveLoading: (state) => state.active.isLoading,
      isActivePaused: (state) => state.active.is_paused,
    },
    mutations: mutations({ baseModule }),
    actions: actions({
      makeHttpParamsUrl,
      baseModule,
      serviceAPI,
    }),
  };
};

export default makeSeveralCurrentsModule;
